import crc32 from "crc-32";

export const generateColorByString = str => {
  const hash = crc32.str(str);
  const r = Math.abs((Math.sin(hash) * 256) >> 0);
  const g = Math.abs((Math.sin(hash * 2) * 256) >> 0);
  const b = Math.abs((Math.sin(hash * 3) * 256) >> 0);
  return `rgba(${r}, ${g}, ${b}, 0.5)`;
};
